import { render } from "./PasswordReset.html?vue&type=template&id=2e670260&scoped=true&ts=true"
import script from "./PasswordReset.ts?vue&type=script&lang=ts"
export * from "./PasswordReset.ts?vue&type=script&lang=ts"

import "./PasswordReset.css?vue&type=style&index=0&id=2e670260&scoped=true&lang=css"

import exportComponent from "/home/dev/deployment/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e670260"]])

export default __exports__